import React from 'react';
import Layout from '../Layout';

const NotFound: React.FC = () => {
  return (
    <Layout>
      <div className="custom-page-css flex flex-col flex-1 items-center justify-center gap-2">
        <h1>404 - Page Not Found</h1>
      </div>

      {/* Optional message or link to home page */}
    </Layout>
  );
}

export default NotFound;